import { HeaderProps } from 'components/Header/interfaces';
import { useMemo } from 'react';
import useFidelity from 'stores/fidelity';
import { UseFidelityMenuProps } from '../../interfaces';

export default function useFidelityMenu({
	customerRestriction,
	openForbiddenModal,
}: UseFidelityMenuProps): Pick<
	HeaderProps,
	'fidelityControls' | 'handleClearRetryFetchData' | 'handleSetFidelityData' | 'isRetryFetchDataExpired'
> {
	const { fidelityStore, handleClearRetryFetchData, handleSetFidelityData, isRetryFetchDataExpired } = useFidelity();

	const fidelityControls = useMemo(() => {
		const defaultControls: HeaderProps['fidelityControls'] = { store: fidelityStore };

		if (customerRestriction === 'PARTNER') {
			defaultControls.onClick = openForbiddenModal;
		}

		return defaultControls;
	}, [fidelityStore, customerRestriction]);

	return {
		fidelityControls,
		isRetryFetchDataExpired,
		handleSetFidelityData,
		handleClearRetryFetchData,
	};
}
